import { useContext } from 'react';
import { MParticleContext } from 'tracking/providers/MParticleProvider';

export const useMParticleContext = () => useContext(MParticleContext);
